<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
					<p>{{ microcopy?.summary }}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form class="w-100" @submit.prevent>
			<div class="rounded-container">
				<div class="row">
					<div class="col d-flex flex-column flex-md-row rounded-container__btn-col-x3">
						<fieldset>
							<legend class="visually-hidden"><span>Please select an option</span></legend>
							<RadioInputComponent v-for="option in options"
												 :key="option"
												 :options="option"
												 :selected-option="selected"
												 @selected="(payload) => {
								selected = payload;
								this.postCustomerProfession(selected);
							}" />
						</fieldset>
					</div>
				</div>
			</div>

			<div class="row btm-btn-group m-auto mb-5">
				<div class="col text-center d-flex flex-column align-items-center">
					<GenericButton :label-text="progressionText"
								   :button-disabled="!selected.selected"
								   @button-click="handleClick" />
					<BackButton @back-click="handleBackButton"
								:back-text="microcopy?.backButtonLabel"
								style="margin-top: 32px;" />
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
	import GenericButton from '@/shared/components/GenericButton.vue';
	import BackButton from '@/shared/components/BackButton.vue';

	import router from '../router/index.js';

	import { mapStores, mapState, mapActions } from 'pinia';
	import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

	export default {
		components: {
			RadioInputComponent,
			GenericButton,
			BackButton,
		},
		data() {
			return {
				progressionText: '',
				options: {
					hospital: {
						text: 'Hospital',
						icon: '/assets/images/hospital-profession.svg',
						type: 'HospitalDoctor',
					},
					gp: {
						text: 'GP Practice',
						icon: '/assets/images/gp-profession.svg',
						type: 'GP',
					},
					dental: {
						text: 'Dental',
						icon: '/assets/images/dental-profession.svg',
						type: 'Dentist',
					},
					education: {
						text: 'Education',
						icon: '/assets/images/education-profession.svg',
						type: 'Teacher',
					},
					other: {
						text: 'Other',
						icon: '/assets/images/other-profession.svg',
						type: 'Wesleyan',
					},
				},
				selected: {},
				microcopy: ''
			};
		},
		computed: {
			...mapStores(useAppointmentReferralStore),
			...mapState(useAppointmentReferralStore, ['postcode', 'profession', 'existingCustomerDetails', 'customerProfession']),
			nextPage() {
				return 'postcode';
			},
		},
		mounted() {
			this.resetExistingCustomerDetails;

			const storedSelection = this.customerProfession;
			if (storedSelection) {
				this.selected = storedSelection;
			}
			this.microcopy = window.bookAnAppointmentReferralMicrocopy?.profession;
			this.assignMicrocopyText();
			document.title = this.microcopy?.metaTitle
		},
		methods: {
			...mapActions(useAppointmentReferralStore, ['postProfession', 'resetExistingCustomerDetails', 'postCustomerProfession']),
			handleClick() {
				this.postProfession(this.selected);
				router.push(this.nextPage);
			},
			handleBackButton() {
				router.back();
			},
			assignMicrocopyText() {
				this.progressionText = this.microcopy?.nextButtonLabel;
			}
		},
	};
</script>
